import React, { useState, useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  PageTitleAndSubTitle,
  // OverviewCard as OverViewCard,
  // valueWithText,
  Breadcrumbs,
  HighCostClaimantsChart,
  CardComponent,
  DashedStandardDropdown,
  BasicTable,
  OverviewCardWithIcon,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { useNavigate } from 'react-router-dom';

import CostTrendChart from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/CostTrend';
import utilizationRx from '../../core-utils/messages/utilizationRx';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  formatPharmacyCostTrendData,
  formatCostBreakDownData,
  topDrugsTableColumn,
  formatTopDrugsData,
  topDrugsTableColumnsForMedPharma,
  getLegendItem,
  getAxisLabelTypography,
  topTherapeuticsTableColumn,
} from './utilizationRxConstants';
import axios from 'axios';
import Loader from '../../_components/molecules/Loader';
import properties from '../../core-utils/properties';
import {
  TotalCost,
  PMPM,
  PEPM,
  TotalEnrolled,
  formatTotalCost,
  formatPMPM,
  formatPEPM,
  formatTotalEnrolled,
  // getPmpmForCohorts,
  // getPmpmValueForCohorts,
  // getPepmForCohorts,
  // getPepmValueForCohorts,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { useStores } from '../../stores';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import Snackbar from '../../_components/atoms/Snackbar';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import messages from '../../core-utils/messages';
import {
  DEEP_DIVE,
  // ENROLLMENT_METRICS,
  MED_PHARMA,
  OTHER_PRESCRIPTION,
  // PLAN_PERFORMANCE,
  SPECIALITY_DRUGS,
} from '../../core-utils/routes';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import componentConstants from '../../core-utils/messages/componentConstants';
import {
  commasForNumbers,
  getToolText,
  numberToCurrencyFormatter,
  numFormatterWithSuffix,
} from '../../core-utils/helper-utils/helper';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import {
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
// import QueryIcon from '../../_components/atoms/Icons/QueryIcon';
import { observer } from 'mobx-react';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import { DottedText } from '../../core-utils/helper-utils/financialForensicsHelper';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';

export interface IPharmacyCostTrendData {
  medpharmaDrugsData: { value: number }[];
  specialityDrugsData: { value: number }[];
  otherPrescriptionDrugsData: { value: number }[];
  xAxisValues: {
    label: string;
  }[];
}

export interface ICostBreakDownData {
  medPharmaDrugsCost: number;
  specialityDrugsCost: number;
  otherPrescriptionDrugsCost: number;
  totalCost: number;
}

export interface ITopDrugsResponse {
  totalCost: number;
  medication: string;
  drugType: string;
  claimsCount: number;
  claimantsCount: number;
  costChange: number;
  atcLevel: string;
  claimType: string;
}

const UtilizationRx: React.FC = observer(({}) => {
  //Styles
  const useStyles = makeStyles()({
    mainDiv: {
      marginTop: '40px',
      marginLeft: '63px',
      width: '1182px',
      marginBottom: '60px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '24px',
      marginBottom: '28px',
      gap: '24px',
    },

    queryIconGrid: {
      padding: '10px 0px 10px 22px',
    },
    queryDataOverallGrid: {
      margin: '10px 10px 10px 0px',
      height: '44px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #DADEEF',
      width: '1176px',
      borderRadius: '4px',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    queryDataTypography: {
      padding: '10px 10px',
      height: '44px',
      borderRight: '1px solid #DADEEF',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    queryDataGrid: {
      maxWidth: '400px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: '60px',
    },
    editQueryGrid: {
      padding: '10px 40px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #DADEEF',
    },
    tooltip: {
      backgroundColor: patientAccessTheme.palette.grey[900],
      padding: '10px',
      fontSize: '13px',
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '16px',
      color: patientAccessTheme.palette.status.white,
    },
    arrow: {
      color: patientAccessTheme.palette.grey[900],
      marginLeft: '50px',
    },
    popper: {
      marginTop: '-20px',
      marginLeft: '-20px',
    },
    circularLoader: {
      display: 'flex',
      height: '450px',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
  const { classes } = useStyles();

  //Contants
  const pageConstants = componentConstants.PAGES.UTILIZATION_RX;
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const navigate = useNavigate();
  const [loader] = useState<any>(<Loader />);

  //Stores
  const loginPageStore = useStores().loginPageStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const employerGroupStore = useStores().employerGroupStore;
  const quaterlyReportStore = useStores().quaterlyReportStore;
  const pathStore = useStores().pathStore;

  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quaterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();

  //state variables
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  const [totalEnrolled, setTotalEnrolled] = useState<TotalEnrolled>({
    dependents: '',
    totalCount: '',
    employees: '',
  });

  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });

  const [pmpm, setPMPM] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });

  const [pepm, setPEPM] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [
    pharmacyCostTrendData,
    setPharmacyCostTrendData,
  ] = useState<IPharmacyCostTrendData>({
    medpharmaDrugsData: [],
    specialityDrugsData: [],
    otherPrescriptionDrugsData: [],
    xAxisValues: [],
  });
  const [
    costBreakDownData,
    setCostBreakDownData,
  ] = useState<ICostBreakDownData>({
    medPharmaDrugsCost: 0,
    specialityDrugsCost: 0,
    otherPrescriptionDrugsCost: 0,
    totalCost: 0,
  });
  const [topDrugsByValue, setTopDrugsByValue] = useState<string>(
    pageConstants.ALL_DRUGS,
  );
  const [topDrugsTableData, setTopDrugsTableData] = useState<any>([]);
  const [
    isPreviousYearAvailable,
    setIsPreviousYearAvailable,
  ] = useState<boolean>(true);
  const [isTopDrugsTableLoading, setIsTopDrugsTableLoading] = useState<boolean>(
    false,
  );
  const [
    topDrugsTableCurrentPage,
    setTopDrugsTableCurrentPage,
  ] = useState<number>(1);
  const [
    topDrugsTableTotalPages,
    setTopDrugsTableTotalPages,
  ] = useState<number>(20);

  const [sortField, setSortField] = useState(pageConstants.MAIN_SORT_COLUMN);
  const [sortOrder, setSortOrder] = useState(pageConstants.MAIN_SORT_ORDER);

  const [columnId, setColumnId] = useState<string>();
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const { open, openModal, closeModal, isEditMode } = useCohortModal();
  const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const screenName = allScreenLabel;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //Top Therapeutic
  const [topTherapeuticsTableData, setTopTherapeuticsTableData] = useState<any>(
    [],
  );
  const [
    isTopTherapeuticsTableLoading,
    setIsTopTherapeuticsTableLoading,
  ] = useState<boolean>(false);
  const [
    topTherapeuticsTableCurrentPage,
    setTopTherapeuticsTableCurrentPage,
  ] = useState<number>(1);
  const [
    topTherapeuticsTableTotalPages,
    setTopTherapeuticsTableTotalPages,
  ] = useState<number>(20);
  const [therapeuticsSortField, setTherapeuticsSortField] = useState(
    pageConstants.MAIN_SORT_COLUMN,
  );
  const [therapeuticssortOrder, setTherapeuticsSortOrder] = useState(
    pageConstants.MAIN_SORT_ORDER,
  );
  const [therapeuticsColumnId, setTherapeuticsColumnId] = useState<string>();

  //Summary
  const [summaryData, setSummaryData] = useState<any>();

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  //Functions
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        utilizationRx.titleAndSubtitle.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleTherapeuticsSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setTherapeuticsSortField(sortColumnName);
    setTherapeuticsSortOrder(sortOrder);
  };

  const handleTopDrugsTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setTopDrugsTableCurrentPage(value);
  };

  const handleTopTherapeuticsTablePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setTopTherapeuticsTableCurrentPage(value);
  };

  const handleOnClick = (value: string, key: string) => {
    navigate(DEEP_DIVE, {
      state: {
        key: key,
        value: value,
      },
    });
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  //click Here Navigation Functions -
  // const pushToEnrollemntMetrics = () => {
  //   history.push(ENROLLMENT_METRICS, {});
  // };
  // const pushToPlanPerformance = () => {
  //   history.push(PLAN_PERFORMANCE, {});
  // };

  const legendItems = (
    <>
      {getLegendItem('#08C7B4', 'Medpharma Drugs', true, () => {
        navigate(MED_PHARMA);
      })}
      {getLegendItem(
        patientAccessTheme.palette.warning[500] ?? '',
        'Speciality Drugs',
        true,
        () => {
          navigate(SPECIALITY_DRUGS);
        },
      )}
      {getLegendItem(
        patientAccessTheme.palette.primary[300] ?? '',
        'Non-Speciality Drugs',
        true,
        () => {
          navigate(OTHER_PRESCRIPTION);
        },
      )}
    </>
  );

  const PharmacyCostTrendProps = (
    medpharmaDrugsData: any,
    specialityDrugsData: any,
    otherPrescriptionDrugsData: any,
    xAxisValues: any,
  ) => {
    return {
      showDBIcon: false,
      chartTitle: 'Drug Cost Trend',
      chartSubTitle: 'Click on a category to view additional data',
      showClickHere: false,
      cardWidth: '777px',
      cardHeight: '405px',
      datasetProp: [
        {
          seriesname: 'Medpharma Drugs',
          plottooltext: 'Medpharma Drugs - $dataValue',
          data: medpharmaDrugsData,
          color: '#08C7B4',
        },
        {
          seriesname: 'Speciality Drugs',
          plottooltext: 'Speciality Drugs - $dataValue',
          data: specialityDrugsData,
          color: patientAccessTheme.palette.warning[500],
        },
        {
          seriesname: 'Non-Speciality Drugs',
          plottooltext: 'Non-Speciality Drugs - $dataValue',
          data: otherPrescriptionDrugsData,
          color: patientAccessTheme.palette.primary[300],
        },
      ],
      chartWidth: '700',
      chartHeight: '280',
      xAxisTitle: '',
      yAxisTitle: ' ',
      sAxisTitle: ' ',
      chartType: 'stackedcolumn2d',
      xAxisValues,
      numberPrefix: '$',
      showLegend: '0',
      customLegend: (
        <Grid
          container
          style={{ position: 'absolute', bottom: '16px', left: '144px' }}
        >
          {legendItems}
        </Grid>
      ),
      customYAxisTitle: getAxisLabelTypography('Cost', {
        top: '76px',
        left: '44px',
      }),
      customXAxisTitle: getAxisLabelTypography('Months', {
        bottom: '64px',
        right: '40px',
      }),
      spaceBetweenTitleAndChart: '24px',
    };
  };

  const CostBreakdownChartProps = (
    medPharmaCost: number,
    specialityCost: number,
    otherCost: number,
    totalCost: number,
  ) => {
    return {
      data: [
        {
          value: medPharmaCost,
          label: pageConstants.DRUG_TYPES.MEDPHARMA,
          color: '#08C7B4',
          toolText: getToolText(medPharmaCost),
        },
        {
          value: specialityCost,
          label: pageConstants.DRUG_TYPES.SPECIALITY,
          color: patientAccessTheme.palette.warning[500],
          toolText: getToolText(specialityCost),
        },
        {
          value: otherCost,
          label: pageConstants.DRUG_TYPES.OTHER,
          color: patientAccessTheme.palette.primary[300],
          toolText: getToolText(otherCost),
        },
      ],
      centerLabel: `$${numFormatterWithSuffix(totalCost)}`,
      centerLabelBold: true,
      centerLabelFontSize: '14',
      cardHeight: '405px',
      cardWidth: '376px',
      title: 'Cost Breakdown',
      subtitle: 'Click on a category to view additional data',
      clickHere: '',
      tooltip: '',
      showSearchDB: false,
      customLegend: (
        <Grid
          container
          sx={{
            justifyContent: 'center',
          }}
        >
          {legendItems}
        </Grid>
      ),
      decimals: '2',
      formatNumberScale: '1',
      numberPrefix: '$',
    };
  };

  const getPath = () => {
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  const getTopDrugsTableColumns = () => {
    return topDrugsByValue === pageConstants.DRUG_TYPES.MEDPHARMA
      ? topDrugsTableColumnsForMedPharma
      : topDrugsTableColumn;
  };

  //Api call functions
  const getTotalEligible = async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.summaryBaseUrl,
        {
          ...payload,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          claim_id_list: cohortDetailsStore.claimIdList,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setTotalEnrolled(formatTotalEnrolled(res?.data?.data));
          setTotalCost(formatTotalCost(res?.data?.data));
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getPMPMAndPepm = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pmpmAndPepm,
        {
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          claim_id_list: cohortDetailsStore.claimIdList,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setPMPM(formatPMPM(res?.data?.data?.pmpm));
          setPEPM(formatPEPM(res?.data?.data?.pepm));
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const getPharmacyCostTrendChartData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.pharmacyCostTrend;
    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res) {
          setPharmacyCostTrendData(
            formatPharmacyCostTrendData(res?.data?.data),
          );
        }
      })
      .catch(() => {});
  };

  const getCostBreakDownChartData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.costBreakDown;
    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          setCostBreakDownData(formatCostBreakDownData(res?.data?.data));
        }
      })
      .catch(() => {});
  };

  const getTopDrugsTableData = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topDrugs;
    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      medicationTypeList:
        topDrugsByValue === pageConstants.ALL_DRUGS
          ? [...Object.values(pageConstants.DRUG_TYPES)]
          : [topDrugsByValue],
      pageNumber: topDrugsTableCurrentPage - 1,
      sortField: sortField,
      sortOrder: sortOrder,
    };
    setIsTopDrugsTableLoading(true);
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          setIsPreviousYearAvailable(res?.data?.data?.isPreviousYearAvailable);
          setTopDrugsTableData(
            formatTopDrugsData(
              res?.data?.data?.topDrugs,
              topDrugsByValue === pageConstants.DRUG_TYPES.MEDPHARMA,
              false,
              handleOnClick,
            ),
          );
          setTopDrugsTableTotalPages(
            Math.ceil(res?.data?.data?.totalCount / 10),
          );
          setIsTopDrugsTableLoading(false);
        }
      })
      .catch((error) => {
        setIsTopDrugsTableLoading(false);
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getTopTherapeutics = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topTherapeutics;
    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      pageNumber: topTherapeuticsTableCurrentPage - 1,
      sortField: therapeuticsSortField,
      sortOrder: therapeuticssortOrder,
    };
    setIsTopTherapeuticsTableLoading(true);
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          const topTherapeutics = res?.data?.data?.topTherapeutics;
          const formattedData = topTherapeutics?.map((item: any) => [
            <DottedText
              text={item?.therapeuticClass}
              onClick={() =>
                handleOnClick(item?.therapeuticClass, 'atc_level3_desc')
              }
            />,
            numberToCurrencyFormatter(item?.totalCost, true),
            item?.claimantsCount ? item?.claimantsCount : '-',
            item?.claimsCount ? item?.claimsCount : '-',
          ]);

          setTopTherapeuticsTableData(formattedData);
          setTopTherapeuticsTableTotalPages(
            Math.ceil(res?.data?.data?.totalCount / 10),
          );
          setIsTopTherapeuticsTableLoading(false);
        }
      })
      .catch((error) => {
        setIsTopTherapeuticsTableLoading(false);
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getUtilizationSummary = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.drugUtilizationSummary;
    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    await axios
      .post(baseUrl, body, { signal: abortController.signal })
      .then((res: any) => {
        if (res?.status === 200) {
          setSummaryData(res?.data?.data);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
      });
  };

  const getTopDrugsForAI = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topDrugs;

    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      medicationTypeList:
        topDrugsByValue === pageConstants.ALL_DRUGS
          ? [...Object.values(pageConstants.DRUG_TYPES)]
          : [topDrugsByValue],
      includeAll: true,
    };

    const res = await axios.post(baseUrl, body);
    return res?.data?.data?.topDrugs ?? [];
  };
  const getTopTherapeuticsForAI = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.utilizationRxBaseUrl +
      properties.topTherapeutics;

    const body = {
      ...payload,
      claim_id_list: cohortDetailsStore.claimIdList,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
      showAll: true,
    };

    const res = await axios.post(baseUrl, body);
    return res?.data?.data?.topTherapeutics ?? [];
  };
  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // only fetch full table data
      const [topDrugs, topTherapeutics] = await Promise.all([
        getTopDrugsForAI(),
        getTopTherapeuticsForAI(),
      ]);

      const apiResponses = {
        title_1: {
          totalEnrolled,
          totalCost,
          pmpm,
          pepm,
        },

        title_2: summaryData,

        title_3: pharmacyCostTrendData,

        title_4: costBreakDownData,

        title_5: topDrugs?.map((item: any) => ({
          drugName: item?.medication,
          totalCost: item?.totalCost,
          claimantsCount: item?.claimantsCount,
          claimsCount: item?.claimsCount,
        })),

        title_6: topTherapeutics?.map((item: any) => ({
          therapeuticClass: item?.therapeuticClass,
          totalCost: item?.totalCost,
          claimantsCount: item?.claimantsCount,
          claimsCount: item?.claimsCount,
        })),
      };

      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.RX_UTILIZATION,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      handleOpenSnackBar(
        error?.response?.data?.error ?? messages.SOMETHING_WENT_WRONG,
        'error',
        6000,
      );
    } finally {
      setAiLoading(false);
    }
  };

  const apiCalls = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        getTotalEligible(),
        getPMPMAndPepm(),
        getPharmacyCostTrendChartData(),
        getCostBreakDownChartData(),
        getUtilizationSummary(),
      ]).then(() => {
        setLoading(false);
      }));

    setLoading(false);
  };

  //Useeffects
  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    isPlanDatesFetched && getTopDrugsTableData();
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    topDrugsByValue,
    topDrugsTableCurrentPage,
    cohortDetailsStore.conditionsDetails,
    sortField,
    sortOrder,
  ]);

  useEffect(() => {
    isPlanDatesFetched && getTopTherapeutics();
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    topTherapeuticsTableCurrentPage,
    cohortDetailsStore.conditionsDetails,
    therapeuticsSortField,
    therapeuticssortOrder,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  //Components
  const GetPath = () => {
    return (
      <Box style={{ marginBottom: '20px' }}>
        <Breadcrumbs
          itemList={[
            [
              'text',
              'Utilization Summary',
              {
                color: patientAccessTheme.palette.primary[500],
                fontWeight: 500,
              },
              () => {
                navigate(
                  `/dashboard/${encodeURIComponent('Drug Utilization')}`,
                );
              },
            ],
            [
              'text',
              utilizationRx.titleAndSubtitle.title,
              {
                color: patientAccessTheme.palette.text.highemphasis,
                fontWeight: 600,
              },
            ],
          ]}
        />
      </Box>
    );
  };

  const EnrollmentAnalysis = () => {
    const {
      planPaidTitle,
      planPaidInfo,
      memberPaidTitle,
      memberPaidInfo,
      claimsTitle,
      claimsInfo,
      brandToGenericRatioTitle,
      brandToGenericRatioInfo,
      specialityDrugPercentInfo,
      specialityDrugPercentTitle,
    } = utilizationRx.cardText;
    const titleTypographyStyles = {
      fontSize: '14px',
      lineHeight: '24px',
      color: `${patientAccessTheme.palette.text.highemphasis}`,
      fontWeight: 600,
      margin: '0px 4px 0px 0px',
    };
    const valueStyles = {
      fontSize: '20px',
      lineHeight: '42px',
      color: `${patientAccessTheme.palette.text.highemphasis}`,
      fontWeight: 600,
      display: 'flex',
      gap: '0.3rem',
    };
    return (
      <Box className={classes.flexContainer}>
        <OverviewCardWithIcon
          title={planPaidTitle}
          values={[
            [
              '$' + commasForNumbers(summaryData?.totalPlanPaid?.toString()),
              '',
            ],
          ]}
          // percentValues={valueWithPercentage('0%', false)}
          rootStyles={{
            height: '100px',
            width: '206px',
          }}
          titleTypographyStyles={titleTypographyStyles}
          valueStyles={valueStyles}
          toolTipContent={planPaidInfo}
          toolTipStyles={{
            width: '222px',
          }}
        />
        <OverviewCardWithIcon
          title={memberPaidTitle}
          values={[
            [
              '$' + commasForNumbers(summaryData?.totalMemberPaid?.toString()),
              '',
            ],
          ]}
          // percentValues={valueWithPercentage('0%', false)}
          rootStyles={{
            height: '100px',
          }}
          titleTypographyStyles={titleTypographyStyles}
          valueStyles={valueStyles}
          toolTipContent={memberPaidInfo}
          toolTipStyles={{
            width: '222px',
          }}
        />
        <OverviewCardWithIcon
          title={claimsTitle}
          values={[
            [commasForNumbers(summaryData?.totalClaims?.toString()), ''],
          ]}
          // percentValues={valueWithPercentage('0%', false)}
          rootStyles={{
            height: '100px',
            width: '180px',
          }}
          titleTypographyStyles={titleTypographyStyles}
          valueStyles={valueStyles}
          toolTipContent={claimsInfo}
          toolTipStyles={{
            width: '222px',
          }}
        />
        <OverviewCardWithIcon
          title={brandToGenericRatioTitle}
          values={[[summaryData?.brandToGeneric?.ratio?.toString(), '']]}
          // percentValues={valueWithPercentage('0%', false)}
          rootStyles={{
            height: '100px',
          }}
          titleTypographyStyles={titleTypographyStyles}
          valueStyles={valueStyles}
          toolTipContent={brandToGenericRatioInfo}
          toolTipStyles={{
            width: '222px',
          }}
        />
        <OverviewCardWithIcon
          title={specialityDrugPercentTitle}
          values={[
            [summaryData?.specialityStats?.percentage.toString() + '%', ''],
          ]}
          // percentValues={valueWithPercentage('0%', false)}
          rootStyles={{
            height: '100px',
          }}
          titleTypographyStyles={titleTypographyStyles}
          valueStyles={valueStyles}
          toolTipContent={specialityDrugPercentInfo}
          toolTipStyles={{
            width: '222px',
          }}
        />
      </Box>
    );
  };

  return isPlanDatesLoading || loading || isInitializing ? (
    loader
  ) : (
    <>
      <Box className={classes.mainDiv}>
        {getPath().length !== 0 ? (
          <Box style={{ marginBottom: '20px' }}>
            <Breadcrumbs itemList={getPath()} />
          </Box>
        ) : (
          <GetPath />
        )}
        <Box
          style={{
            width: '1182px',
            position: 'relative',
            marginBottom: '18px',
          }}
        >
          <PageTitleAndSubTitle
            title={utilizationRx.titleAndSubtitle.title}
            subTitle={utilizationRx.titleAndSubtitle.subtitle}
            showDownloadButton={true}
            showQueryDataButton={checkUserAccess(
              UserAccessConstants.COHORT_DETAILS,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )}
            queryButtonText={
              cohortDetailsStore.cohortDetailsList?.length > 0 &&
              cohortDetailsStore.cohortDetailsList[0].category !== ''
                ? 'Edit Cohort'
                : 'Add Cohort'
            }
            queryDataAction={() => {
              if (
                checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )
              ) {
                openModal();
              }
            }}
            // downloadButtonAction={() => setOpenReportsModal(true)}
            downloadButtonAction={() => {
              downloadPdf(
                'utilizationPharmacyReport',
                {
                  employer:
                    employerGroupStore?.employerGroupResponseData
                      ?.employer_group_name,
                  member_unique_id_list: [],
                  claim_id_list: [],
                  maxClaimDate:
                    employerGroupStore?.employerGroupResponseData
                      ?.max_claim_date,
                  ...payload,
                },
                handleOpenSnackBar,
                'open',
              );
              handleOpenSnackBar(
                snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                'info',
                6000,
              );
            }}
            chip={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px 0px 0px"
                >
                  {COMMON_TEXTS.FOR}
                </Typography>
                <DateFilter />
              </div>
            }
            showAskAi={true}
            askAiAction={handleAskAi}
          />
          {/* edit duration */}

          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedIndex}
            recommendationFetched={recommendationFetched}
          />
        </Box>

        {selectedTabIndex === 0 && (
          <>
            <CohortFilterBar />
            <EnrollmentAnalysis />
            <Grid
              container
              style={{ width: '100%' }}
              sx={{
                justifyContent: 'space-between',
              }}
            >
              <CostTrendChart
                {...PharmacyCostTrendProps(
                  pharmacyCostTrendData.medpharmaDrugsData,
                  pharmacyCostTrendData.specialityDrugsData,
                  pharmacyCostTrendData.otherPrescriptionDrugsData,
                  pharmacyCostTrendData.xAxisValues,
                )}
              />
              <HighCostClaimantsChart
                {...CostBreakdownChartProps(
                  costBreakDownData.medPharmaDrugsCost,
                  costBreakDownData.specialityDrugsCost,
                  costBreakDownData.otherPrescriptionDrugsCost,
                  costBreakDownData.totalCost,
                )}
              />
            </Grid>
            <Grid style={{ marginTop: '28px' }}>
              <CardComponent
                title={pageConstants.TOP_DRUGS_TABLE.TITLE}
                subTitle={pageConstants.TOP_DRUGS_TABLE.SUBTITLE}
                height="auto"
                width="1177px"
                dropdownElement={
                  <DashedStandardDropdown
                    options={pageConstants.TOP_DRUGS_TABLE.DROPDOWN_VALUES}
                    displayValue={
                      pageConstants.TOP_DRUGS_TABLE.DROPDOWN_DISPLAY_VALUES
                    }
                    value={topDrugsByValue}
                    handleChange={(event: any) => {
                      const value: string = event.target.value as string;
                      setTopDrugsByValue(value);
                      setSortField(pageConstants.MAIN_SORT_COLUMN);
                      setSortOrder(pageConstants.MAIN_SORT_ORDER);
                      setTopDrugsTableCurrentPage(1);
                    }}
                  />
                }
                body={
                  isTopDrugsTableLoading ? (
                    <Box className={classes.circularLoader}>
                      <CircularLoader />
                    </Box>
                  ) : (
                    <>
                      <BasicTable
                        columns={getTopDrugsTableColumns()}
                        cellHeight="56px"
                        cellPadding="12px 9px 12px 14px"
                        rowsData={topDrugsTableData}
                        displayType="row"
                        tableHeight="auto"
                        columnId={columnId}
                        handleHeaderMouseEnter={(column: any) =>
                          handleHeaderMouseEnter(column, setColumnId)
                        }
                        handleHeaderMouseLeave={() =>
                          handleHeaderMouseLeave(setColumnId)
                        }
                        showOnHoverHeader={true}
                        handleMenuItem={handleSort}
                        width="1100px"
                        hideColumnIndex={
                          !isPreviousYearAvailable
                            ? topDrugsByValue ===
                              pageConstants.DRUG_TYPES.MEDPHARMA
                              ? 2
                              : 4
                            : -1
                        }
                        noDataText={messages.NO_DATA_DRUGS}
                      />
                      <Grid
                        container
                        style={{
                          marginTop: '16px',
                        }}
                        sx={{
                          justifyContent: 'flex-end',
                        }}
                      >
                        <Pagination
                          page={topDrugsTableCurrentPage}
                          count={topDrugsTableTotalPages}
                          onChange={handleTopDrugsTablePageChange}
                          size="small"
                          color="primary"
                        />
                      </Grid>
                    </>
                  )
                }
              />
            </Grid>
            <Grid style={{ marginTop: '28px' }}>
              <CardComponent
                title={'Top Therapeutic Class of Drugs'}
                height="auto"
                width="1177px"
                titleSubTitleMargin="10px"
                body={
                  isTopTherapeuticsTableLoading ? (
                    <Box className={classes.circularLoader}>
                      <CircularLoader />
                    </Box>
                  ) : (
                    <>
                      <BasicTable
                        columns={topTherapeuticsTableColumn}
                        cellHeight="56px"
                        cellPadding="12px 9px 12px 14px"
                        rowsData={topTherapeuticsTableData}
                        displayType="row"
                        tableHeight="auto"
                        columnId={therapeuticsColumnId}
                        handleHeaderMouseEnter={(column: any) =>
                          handleHeaderMouseEnter(
                            column,
                            setTherapeuticsColumnId,
                          )
                        }
                        handleHeaderMouseLeave={() =>
                          handleHeaderMouseLeave(setTherapeuticsColumnId)
                        }
                        showOnHoverHeader={true}
                        handleMenuItem={handleTherapeuticsSort}
                        width="1100px"
                        noDataText={'No data available'}
                      />
                      <Grid
                        container
                        style={{
                          marginTop: '16px',
                        }}
                        sx={{
                          justifyContent: 'flex-end',
                        }}
                      >
                        <Pagination
                          page={topTherapeuticsTableCurrentPage}
                          count={topTherapeuticsTableTotalPages}
                          onChange={handleTopTherapeuticsTablePageChange}
                          size="small"
                          color="primary"
                        />
                      </Grid>
                    </>
                  )
                }
              />
            </Grid>
          </>
        )}
        {selectedTabIndex === 1 && (
          <RecommendationsTab
            recommendationLoading={recommendationLoading}
            isInternalPage={true}
          />
        )}
      </Box>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        }
        endDate={
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        }
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <FeatureAccessModal
        open={openFeatureAccessModal}
        handleClose={() => {
          setOpenFeatureAccessModal(false);
        }}
        access={checkUserAccess(
          UserAccessConstants.COHORT_DETAILS,
          loginPageStore.userResponse.role.name,
          loginPageStore.userFeatures,
        )}
      ></FeatureAccessModal>
    </>
  );
});

export default UtilizationRx;
